import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const fmtSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
};

// V71 — renkler token (dark temada da okunur); gradyan başlık korunur
const Shell = ({ children }) => (
  <div style={{
    minHeight: '100vh', background: 'linear-gradient(135deg, var(--bg-canvas) 0%, var(--info-50) 100%)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
  }}>
    <div style={{ background: 'var(--bg-surface)', color: 'var(--fg-primary)', borderRadius: 14, boxShadow: 'var(--shadow-xl)', border: '1px solid var(--border-subtle)', maxWidth: 480, width: '100%', overflow: 'hidden' }}>
      <div style={{ background: 'var(--grad-brand-bright)', color: '#fff', padding: '20px 28px' }}>
        <div style={{ fontSize: 13, opacity: 0.9, fontWeight: 500 }}>MTU Travel</div>
        <div style={{ fontSize: 18, fontWeight: 700, marginTop: 2 }}>Güvenli Dosya Paylaşımı</div>
      </div>
      <div style={{ padding: '24px 28px' }}>{children}</div>
      <div style={{ padding: '12px 28px', borderTop: '1px solid var(--border-subtle)', textAlign: 'center', fontSize: 11, color: 'var(--fg-tertiary)' }}>
        🔒 Bu link MTU Agent HUB tarafından üretildi · hub.mtutravel.com.tr
      </div>
    </div>
  </div>
);

const Status = ({ icon, color, title, text }) => (
  <div style={{ textAlign: 'center', padding: '16px 0' }}>
    <div style={{ fontSize: 40 }}>{icon}</div>
    <h3 style={{ margin: '8px 0 4px', fontSize: 16, fontWeight: 700, color }}>{title}</h3>
    {text && <p style={{ margin: 0, fontSize: 13, color: 'var(--fg-secondary)' }}>{text}</p>}
  </div>
);

// V71 — işlem hatası (yanlış şifre, yükleme hatası) formu silmez; üstte gösterilir, tekrar denenebilir
const ActionError = ({ text }) => text ? (
  <div className="alert-danger" style={{ marginBottom: 12 }}>⚠️ {text}</div>
) : null;

const muted = { fontSize: 12, color: 'var(--fg-secondary)' };
const primaryBtn = { marginTop: 16, width: '100%', justifyContent: 'center', padding: '12px 16px', fontSize: 14 };

export const PublicDownload = () => {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [actionError, setActionError] = useState('');
  const [password, setPassword] = useState('');
  const [verifying, setVerifying] = useState(false);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/public/info/${token}`)
      .then(async r => {
        if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.error || `Hata ${r.status}`); }
        return r.json();
      })
      .then(setInfo)
      .catch(e => setError(e.message));
  }, [token]);

  const startDownload = async () => {
    setDownloading(true);
    setActionError('');
    if (info?.has_password) {
      // Önce verify, sonra download
      setVerifying(true);
      try {
        const r = await fetch(`${API_BASE}/public/verify/${token}`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ password }),
        });
        if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.error || 'Şifre yanlış'); }
      } catch (e) { setActionError(e.message); setDownloading(false); setVerifying(false); return; }
      setVerifying(false);
      // V71 — şifre URL'ye (geçmiş/sunucu logu) yazılmaz: başlıkla indirilir, dosya tarayıcıda kaydedilir
      try {
        const r = await fetch(`${API_BASE}/public/d/${token}`, { headers: { 'x-link-password': password } });
        if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.error || `Hata ${r.status}`); }
        const blob = await r.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = info.file?.name || 'dosya';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      } catch (e) { setActionError(e.message || 'İndirme başarısız'); }
      setDownloading(false);
      return;
    }
    // Şifresiz: doğrudan indirme
    window.location.href = `${API_BASE}/public/d/${token}`;
    setTimeout(() => setDownloading(false), 1500);
  };

  if (error) return <Shell><Status icon="⚠️" color="var(--danger-600)" title="Erişim Yok" text={error} /></Shell>;
  if (!info) return <Shell><Status icon="⏳" color="var(--fg-secondary)" title="Yükleniyor..." /></Shell>;
  if (info.kind !== 'download') return <Shell><Status icon="ℹ️" color="var(--fg-brand)" title="Bu link yükleme içindir" text="URL'yi kontrol edin." /></Shell>;

  return (
    <Shell>
      <ActionError text={actionError} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: '1px solid var(--border-subtle)' }}>
        <div style={{ fontSize: 32 }}>📄</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, color: 'var(--fg-heading)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{info.file?.name || 'Dosya'}</div>
          <div style={muted}>{info.file ? fmtSize(info.file.size) : ''}</div>
        </div>
      </div>
      {info.expires_at && (
        <div style={{ ...muted, marginTop: 12 }}>
          ⏱️ Bitiş: {new Date(info.expires_at).toLocaleString('tr-TR')}
        </div>
      )}
      {info.remaining != null && (
        <div style={{ ...muted, marginTop: 6 }}>
          📥 Kalan indirme hakkı: {info.remaining}
        </div>
      )}
      {info.has_password && (
        <div className="form-group" style={{ marginTop: 14 }}>
          <label className="form-label">Şifre</label>
          <input type="password" className="form-input" value={password} onChange={e => { setPassword(e.target.value); setActionError(''); }} autoFocus
            onKeyDown={e => { if (e.key === 'Enter' && password && !downloading) startDownload(); }} />
        </div>
      )}
      <button className="btn btn-brand" onClick={startDownload} disabled={downloading || (info.has_password && !password)} style={primaryBtn}>
        {downloading ? (verifying ? 'Doğrulanıyor...' : 'İndiriliyor...') : '⬇️ İndir'}
      </button>
    </Shell>
  );
};

export const PublicUpload = () => {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [actionError, setActionError] = useState('');
  const [password, setPassword] = useState('');
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [success, setSuccess] = useState(0);
  const [drag, setDrag] = useState(false);
  const fileRef = useRef(null);

  useEffect(() => {
    fetch(`${API_BASE}/public/info/${token}`)
      .then(async r => {
        if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.error || `Hata ${r.status}`); }
        return r.json();
      })
      .then(setInfo)
      .catch(e => setError(e.message));
  }, [token]);

  const handleFiles = (list) => {
    if (!list?.length) return;
    setFiles(Array.from(list));
  };

  const startUpload = async () => {
    if (!files.length) return;
    setUploading(true);
    setActionError('');
    try {
      const fd = new FormData();
      files.forEach(f => fd.append('files', f));
      const headers = {};
      if (info?.has_password) headers['x-link-password'] = password;
      const r = await fetch(`${API_BASE}/public/u/${token}`, { method: 'POST', headers, body: fd });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.error || `Hata ${r.status}`); }
      const j = await r.json();
      setSuccess(j.count || files.length);
      setFiles([]);
    } catch (e) { setActionError(e.message); } // V71 — seçilen dosyalar korunur, tekrar denenebilir
    setUploading(false);
  };

  if (error) return <Shell><Status icon="⚠️" color="var(--danger-600)" title="Erişim Yok" text={error} /></Shell>;
  if (!info) return <Shell><Status icon="⏳" color="var(--fg-secondary)" title="Yükleniyor..." /></Shell>;
  if (info.kind !== 'upload') return <Shell><Status icon="ℹ️" color="var(--fg-brand)" title="Bu link indirme içindir" text="URL'yi kontrol edin." /></Shell>;

  if (success > 0) {
    return <Shell>
      <Status icon="✅" color="var(--success-600)" title="Yükleme Tamamlandı" text={`${success} dosya başarıyla yüklendi.`} />
      <button className="btn btn-secondary" onClick={() => { setSuccess(0); setActionError(''); }}
        style={{ marginTop: 12, width: '100%', justifyContent: 'center' }}>
        Yeni dosya yükle
      </button>
    </Shell>;
  }

  return (
    <Shell>
      <ActionError text={actionError} />
      <div style={{ fontSize: 13, color: 'var(--fg-secondary)', marginBottom: 10 }}>
        Hedef klasör: <strong style={{ color: 'var(--fg-heading)' }}>{info.folder_name || 'Ana Klasör'}</strong>
      </div>
      {info.expires_at && (
        <div style={{ ...muted, marginBottom: 4 }}>⏱️ Bitiş: {new Date(info.expires_at).toLocaleString('tr-TR')}</div>
      )}
      <div style={{ ...muted, marginBottom: 10 }}>📦 Max dosya: {info.max_file_mb} MB</div>

      {info.has_password && (
        <div className="form-group" style={{ marginBottom: 12 }}>
          <label className="form-label">Şifre</label>
          <input type="password" className="form-input" value={password} onChange={e => { setPassword(e.target.value); setActionError(''); }} />
        </div>
      )}

      <div
        onDragOver={e => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={e => { e.preventDefault(); setDrag(false); handleFiles(e.dataTransfer.files); }}
        onClick={() => fileRef.current?.click()}
        role="button"
        tabIndex={0}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileRef.current?.click(); } }}
        style={{
          border: drag ? '2px dashed var(--indigo-500)' : '2px dashed var(--border-strong)', borderRadius: 10,
          background: drag ? 'var(--info-50)' : 'var(--bg-surface-2)', padding: 28, textAlign: 'center', cursor: 'pointer',
          transition: 'all .15s',
        }}
      >
        <div style={{ fontSize: 32 }}>📤</div>
        <div style={{ fontSize: 13, color: 'var(--fg-secondary)', marginTop: 6 }}>
          {files.length > 0 ? `${files.length} dosya seçildi` : 'Dosya sürükleyin veya tıklayın'}
        </div>
        <input ref={fileRef} type="file" multiple hidden onChange={e => handleFiles(e.target.files)} />
      </div>

      {files.length > 0 && (
        <ul style={{ margin: '10px 0', padding: 0, listStyle: 'none', fontSize: 12, color: 'var(--fg-secondary)' }}>
          {files.map((f, i) => (
            <li key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>📎 {f.name}</span>
              <span>{fmtSize(f.size)}</span>
            </li>
          ))}
        </ul>
      )}

      <button className="btn btn-brand" onClick={startUpload} disabled={uploading || files.length === 0 || (info.has_password && !password)}
        style={{ ...primaryBtn, marginTop: 12 }}>
        {uploading ? 'Yükleniyor...' : '⬆️ Yükle'}
      </button>
    </Shell>
  );
};

export default PublicDownload;
